export default __webpack_public_path__ + "static/media/jamhawbannerpure.3f2704ca.gif";